import { gql } from "@apollo/client";

import { preSubmissionInfoFragment } from "../fragments";

export const getPreSubmissionInfoQuery = gql`
    query getPreSubmissionInfo($submissionId: ID!) {
        getPreSubmissionInfo(input: { submissionId: $submissionId }) {
            ...PreSubmissionInfo
        }
    }
    ${preSubmissionInfoFragment}
`;
